import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.SectionD');
    const configs = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745462169651/SectionD%20pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745462169467/SectionD%20h5.jpg',
        title: t('title'),
        textPosition: 'center center', // 新增垂直居中配置
    };

    return (
        <div className={styles.comp} id="SectionD">
            <EcoSectionCard theme="black" layout="center-center" {...configs} />
        </div>
    );
}
